<template>
<section class="content">
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4" @click="setToday">Today</v-btn>
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on }">
              <v-btn outlined v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          :style="{ maxHeight: '1000px', overflowY: 'scroll', overflowX: 'hidden' }"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
          min-width="350px" max-width="350px"
        >
          <v-card color="grey lighten-4" min-width="350px" max-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <p>Campaign : <strong>{{selectedEvent.campaignName}}</strong></p>
              <p v-if="selectedEvent.influencer">Influencer :
                <!-- <v-avatar size="35" color="grey lighten-4">
                  <img
                    v-bind:src="selectedEvent.influencer.picture"
                    alt="avatar"
                  >
                </v-avatar> -->
                <!-- <a
                  :href="'https://www.tiktok.com/@' + selectedEvent.influencer.tiktokHandle"
                  target="_blank"
                  v-if="selectedEvent.influencer.tiktokHandle"
                ><img src="/static/img/tiktok-32.png" width="20px" /> @{{selectedEvent.influencer.tiktokHandle}}</a>
                <a
                  :href="'https://instagram.com/' + selectedEvent.influencer.instagramHandle"
                  target="_blank"
                  v-else
                ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{selectedEvent.influencer.instagramHandle}}</a> -->
                <social-handle
                  divClassName="d-inline"
                  :isInstagram="selectedEvent.platform === 'instagram' || !selectedEvent.platform"
                  :isTikTok="selectedEvent.platform === 'tiktok'"
                  :isYoutube="selectedEvent.platform === 'youtube'"
                  :isFacebook="selectedEvent.platform === 'facebook'"
                  :isXiaohongshu="selectedEvent.platform === 'xiaohongshu'"
                  :instagramHandle="selectedEvent.influencer"
                  :tiktokHandle="selectedEvent.influencer"
                  :youtubeHandle="selectedEvent.influencer"
                  :facebookHandle="selectedEvent.influencer"
                  :xiaohongshuHandle="selectedEvent.influencer"
                  :xiaohongshuFullName="selectedEvent.influencer"
                />
              </p>
              <p>Live Date : <strong>{{changeDateFormat(selectedEvent.liveDate)}}</strong></p>
              <p>Last Stats Submission Date : <strong>{{changeDateFormat(selectedEvent.end)}}</strong></p>
              <div class="d-flex flex-row" v-if="selectedEvent.postLinks && selectedEvent.postLinks.length">
                <p>Post Links : </p>
                <div style="padding-left:10px">
                  <div :key="idx" v-for="(item, idx) in selectedEvent.postLinks">
                    <a :href="item" target="_blank">{{ item }}</a>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="selectedOpen = false">Close</v-btn>
              <v-spacer></v-spacer>
              <!-- <v-btn text color="secondary" @click="copyLink(selectedEvent.pairingID)">Copy Stats Link</v-btn> -->
              <v-btn
                @click="viewStatsLink(selectedEvent)"
                color="secondary"
                v-bind="attrs"
                v-on="on"
                small
                text
                v-if="selectedEvent.stats"
              >
                <!-- <v-icon small>mdi-content-copy</v-icon> -->
                <span>View Stats</span>
              </v-btn>
              <v-btn
                @click="copyFormLink(selectedEvent)"
                color="secondary"
                v-bind="attrs"
                v-on="on"
                small
                text
                v-else
              >
                <v-icon small>mdi-content-copy</v-icon>
                <span>Copy Stats Submission</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <view-post-modal
      v-model="viewPostDialog"
      :post="viewPostData"
      :csActions="false"
      :saleActions="false"
      :clientActions="false"
      :influencerActions="false"
      :cs_inf_chatbox="false"
      :postAbuseHistory="false"
      :postReviewApproved="false"
      :postHistory="false"
      :userObj="user"
      :value="viewPostDialog"
    />
    <v-snackbar
      v-model="copySucceeded"
    >
      Copied to Clipboard!
      <v-btn
        color="blue"
        text
        @click="copySucceeded = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <input type="hidden" id="copy-link" :value="formLink">
  </v-row>
</section>
</template>
<script>
import config from '@/config';
import PostAPI from './postApi';
import Utils from '../../../utils';
import moment from 'moment';
import ViewPostModal from './ViewPostModal.vue';
import SocialHandle from '@/components/scoped/custom/SocialHandle'
import pairingAPIs from '../Pairing/pairingAPIs';
import utils from '@/utils';
import influencerAPIs from '../Influencer/influencerAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import uniqBy from 'lodash/uniqBy';

export default {
  components: {
    ViewPostModal,
    SocialHandle
  },
  data: () => ({
    viewPostDialog: false,
    viewPostData: null,
    focus: this.today,
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day'
      // '4day': '4 Days'
    },
    start: null,
    end: null,
    startDate: null,
    endDate: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    loading: false,
    selected: [],
    totalItems: '',
    posts: [],
    formLink: '',
    filter: {
      instagramHandle: null,
      campaignName: null,
      clientID: null,
      today: false,
      story: false
    }
  }),
  computed: {
    user: function() {
      return this.$store.state.user;
    },
    today: function() {
      return moment().format('YYYY-MM-DD')
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long'
      });
    },
    postStatusConfig: function() {
      return config.postStatus;
    }
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.fetchPosts();
  },
  methods: {
    viewDetailPost(postID) {
      PostAPI.getPostById(postID)
        .then(post => {
          this.viewPostData = post;
          this.viewPostDialog = true;
        })
        .catch(err => {
          this.viewPostDialog = false;
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
        });
    },
    fetchPosts() {
      let status = this.postStatusConfig.APPROVE;
      this.loading = true;
      let query = Utils.func.clean(this.filter);
      query.status = status;
      query.lastSevenDate = moment().subtract(6, 'days').format('YYYY-MM-DD')
      if (!this.startDate) this.startDate = moment().format('YYYY-MM-DD')
      if (!this.endDate) this.endDate = moment().format('YYYY-MM-DD')
      query.start = moment(this.startDate).subtract(10, 'days').format('YYYY-MM-DD')
      query.end = moment(this.endDate).add(10, 'days').format('YYYY-MM-DD')
      let campaignIds = []
      campaignAPIs.getReportsForCalendar(query)
        .then(resp => {
          resp = uniqBy(resp, item => `${item.campaignID}|${item.owner}`);
          this.posts = resp
          let eventArray = []
          var eventObj = {}
          let colors = []
          resp.forEach(post => {
            let inf = post.owner
            let labelName = `${inf} (${post.campaignName})`
            let nextSevDays = moment(post.live_date).add(6, 'days').format('YYYY-MM-DD')
            let clr = ''
            let matchColor = colors.find(e => e.campaignID === post.campaignID)
            if (matchColor) {
              clr = matchColor.color
            } else {
              clr = utils.func.getFixedClr()
              colors.push({
                campaignID: post.campaignID,
                color: clr
              })
            }
            eventObj = Object.assign({},
              {
                postID: post.id,
                color: clr,
                influencer: post.owner,
                campaignID: post.campaignID,
                campaignName: post.campaignName,
                name: labelName,
                liveDate: moment(post.live_date).format('YYYY-MM-DD'),
                start: nextSevDays,
                end: nextSevDays,
                postLinks: post.postLinks
              })
            if (post.campaignID) {
              campaignIds.push(post.campaignID)
            }
            eventArray.push(eventObj);
          });
          this.getPairingsByCampaigns(campaignIds)
          this.events = eventArray;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.error(err);
        });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start;
      this.end = end;
      this.startDate = String(start.date);
      this.endDate = String(end.date);
      this.fetchPosts()
    },
    nth(d) {
      return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },
    async getPairingsByCampaigns(campaignIDs) {
      let pairings = await pairingAPIs.getPairedInfluencersByCampaignIDs(campaignIDs)
      let campaignPayouts = await this.getAllCampaignPayouts()
      for (let event of this.events) {
        if (event.campaignID) {
          let pairing = pairings.find(p => p.campaignID === event.campaignID && (p.influencer_details && (event.influencer === p.influencer_details.instagramHandle || event.influencerID === p.influencer_details.influencerID)))
          if (pairing) {
            event.pairingID = pairing.id
            let matchCampaignPayout = campaignPayouts.find(c => c.campaignID === pairing.campaignID && (pairing.influencer_details && (c.handle === pairing.influencer_details.instagramHandle || c.influencerID === pairing.influencer_details.influencerID)))
            if (matchCampaignPayout) {
              event.stats = true
              event.handle = matchCampaignPayout.handle
            }
          }
          // to set platform
          let influencerPairing = pairings.find(p => event.influencer && p.influencer_details.instagramHandle === event.influencer)
          if (influencerPairing) {
            if (influencerPairing.influencer_details) {
              event.platform = influencerPairing.influencer_details.platform || 'instagram'
            }
          }
        }
      }
    },
    async getAllCampaignPayouts() {
      let response = await influencerAPIs.getAllCampaignPayouts({})
      let campaignPayouts = response.data
      // For now, we only retrieve Instagram info
      campaignPayouts = campaignPayouts.map(element => {
        let resultData = {
          campaignName: element.campaignName,
          campaignID: element.campaignID,
          influencerID: element.influencerID
        }
        if (element.tiktok) {
          resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : ''
          resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : ''
          resultData.tiktok_post_url = element.tiktokPostURL
          resultData.platform = 'tiktok'
        } else {
          resultData.handle = element.instagram ? element.instagram.instagramHandle : ''
          resultData.fullName = element.instagram ? element.instagram.instagramFullname : ''
          resultData.instagram_post_url = element.instagramPostURL
          resultData.platform = 'instagram'
        }
        if (!resultData.handle) {
          if (element.handle) {
            resultData.handle = element.handle
            resultData.platform = element.platform || 'instagram'
          }
        }
        return resultData
      })
      return campaignPayouts
    },
    copyFormLink(item) {
      this.copySucceeded = true
      const protocol = window.location.protocol
      const host = window.location.host
      this.formLink = `${protocol}//${host}/submit-post-payout?pairingID=${item.pairingID}`
      setTimeout(function() {
        item.linkCopied = utils.func.copyToClipboard('#copy-link')
      }, 100)
    },
    viewStatsLink(item) {
      window.open(`/campaignPayoutsInternal?influencerID=${item.influencerID}&campaignID=${item.campaignID}&handle=${item.handle}&stats=true`, '_blank')
    },
    changeDateFormat: (date) => moment(date).format('DD-MM-YYYY')
  }
};
</script>



// WEBPACK FOOTER //
// CalenderViewPosts.vue?ccff51a2